import { Modal } from "@mui/material";
import { apiGetPermissions, apiGetRoles } from "api/roleApi";
import { apiAddUser, apiGetUsers, apiUpdateUser } from "api/userApi";
import CrossIcon from "assets/icons/CrossIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import Portal from "components/Portal";
import ModalBox from "components/Shared/Modals/ModalBox";
import Icon from "components/Shared/atoms/Icon";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import PermissionsView from "./PermissionsView";
import PermissionsViewButton from "./PermissionsViewButton";
import { apiGetBranches } from "../../../api/branchApi";

export interface UserAddFormCardProps {
  index?: number;
  icon?: string;
  title?: string;
  onClose?: () => void;
  user?: any;
  isEdit?: boolean;
}
export default function UserFormCard(props: UserAddFormCardProps) {
  const dispatch: any = useDispatch();
  const store = useSelector((state: any) => state);
  const token = store.businessReducer.business.token;
  const roles: Role[] = store.roleReducer.roles;
  const branches: Branch[] = store.branchReducer.branches;
  const permissions: Permission[] = store.permissionReducer.permissions || [];

  const [state, setState] = useState<{
    phone?: number;
    roleId?: number;
    open?: boolean;
    branchId?: number | null;
  }>({
    phone: +props.user?.phone,
    roleId: props.user?.Roles[0]?.id,
    branchId: props.user?.Roles[0]?.Role_User?.BranchId
  });
  const role = roles.find((x) => x.id === state?.roleId);
  const [stateCheckbox, setStateCheckbox] = useState<boolean>(false);
  useEffect(() => {
    setState({
      phone: +props.user?.phone,
      roleId: props.user?.Roles[0]?.id,
      branchId: props.user?.Roles[0]?.Role_User?.BranchId
    });
  }, [props.user]);

  useEffect(() => {
    apiGetPermissions(token, null, dispatch, state?.roleId);
  }, [state?.roleId]);

  useEffect(() => {
    if (stateCheckbox) {
      setState((x) => ({ ...x, branchId: null }));
    }
  }, [stateCheckbox]);

  function handleSubmit() {
    if (props.isEdit) {
      if (props.user?.id) {
        dispatch(apiUpdateUser(props.user.id, null, token, null, state, callback));
      }
      return;
    }
    apiAddUser(dispatch, {}, token, 0, null, null, {
      roleId: state?.roleId,
      ePhone: state?.phone,
      branchId: state?.branchId
    }, callback);
  }

  function callback(res: any) {
    dispatch(apiGetUsers(token));
    props.onClose && props.onClose();
  }

  return (
    <div className="bg-white rounded-md shadow-proportional w-96">
      <div
        className={`w-full flex items-center justify-between p-2 ${
          props.isEdit ? "border-b border-slate-300" : ""
        }`}
      >
        {!props.isEdit && (
          <div className="flex items-center gap-2">
            <span className="text-[#1E40AF]">{props.index}</span>
            <Icon url={props.icon} />
            <span>{props.title}</span>
          </div>
        )}
        {props.isEdit && <div className="px-4">{props.title}</div>}
        <div className="cursor-pointer" onClick={props.onClose}>
          <CrossIcon bgColor="#EBEFF5" color="#7E8C9E" />
        </div>
      </div>
      <div className="flex flex-col gap-4 p-7">
        {props.isEdit && (
          <div className="flex items-center gap-2">
            <Icon url={props.icon} classes={{ l1: "w-14 h-14", l2: "w-9 h-9" }} />
            <div className="flex flex-col gap-2">
              <span className="text-lg">{props.user?.label}</span>
              <span className="text-dark-3">{props.user?.phone}</span>
            </div>
          </div>
        )}
        {!props.isEdit && (
          <BasicTextInput
            label="شماره موبایل"
            type="number-native"
            inputStyle={{ textAlign: "end" }}
            val={state?.phone}
            required={true}
            onChange={(val) => {
              if (typeof val === "number") {
                setState((x) => ({ ...x, phone: val }));
              }
            }}
          />
        )}
        <div className="flex items-end justify-between gap-3">
          <BasicSelect
            options={roles}
            label="نقش"
            withRefresh
            required={true}
            defaultValue={state?.roleId}
            refreshList={() => {
              dispatch(apiGetRoles(token));
            }}
            onChange={(val) => setState((x) => ({ ...x, roleId: val }))}
          />
          {permissions && role && <PermissionsViewButton {...{ permissions, role }} />}
        </div>
        <div className="flex items-end justify-between gap-6">
          <BasicSelect
            label="محدود کردن شخص به شعبه ی انتخابی"
            options={branches}
            withRefresh
            // @ts-ignore
            refreshList={() => dispatch(apiGetBranches(token))}
            defaultValue={state?.branchId}
            onChange={(branchId, branch) =>
              setState((x: any) => ({
                ...x,
                branchId
              }))
            }
          />
          {props.isEdit && (<label className="checkbox">
            <input
              type="checkbox"
              name={" حذف شعبه "}
              checked={stateCheckbox}
              onChange={() => {
                setStateCheckbox(!stateCheckbox);
              }}
            />
            حذف شعبه
          </label>)}
        </div>
      </div>
      <div className="px-7 py-3">
        <BasicButton
          variant="contained"
          onClick={() => {
            handleSubmit();
          }}
        >
          {props.isEdit ? "ویرایش" : "افزودن"}
        </BasicButton>
      </div>
    </div>
  );
}
